import React, { useState } from 'react'
import { useDeleteTagMutation, useGetTagsQuery } from '../Service/tagsApi';
import { useNavigate } from 'react-router-dom';
import { TagsRoutes } from '../../../Router/path';
import { useCreateRedirect } from '../../Shared/Hooks/useCreateRedirect';
import { useDeleteSelectedItems } from '../../Shared/Hooks/useDeleteSelectedItems';
import DataTable, { ColumnConfig } from '../../Shared/Components/DataTable';
import { Tag } from '../Types/tagsType';
import CustomCard from '../../Shared/Components/CustomCard/CustomCard';
import InfoIcon from '@mui/icons-material/Info';
import { Box } from '@mui/system';
import { Typography } from '@mui/material';
import ActionButtons from '../../Shared/Components/ActionButtons';

const Tags = () => {
    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [selectedTagIds, setSelectedTagIds] = useState<number[]>([]);

    const { data, isLoading, isError, error } = useGetTagsQuery()

    const [deleteTag] = useDeleteTagMutation();
    const navigate = useNavigate();
    const handleCreate = useCreateRedirect(TagsRoutes.create);
    const handleDeleteSelected = useDeleteSelectedItems<number>(
        selectedTagIds,
        (id) => deleteTag(id).unwrap(),
        () => setSelectedTagIds([])
    );

    const columns: ColumnConfig<Tag>[] = [
        { key: "id", label: "ID" },
        { key: "name", label: "Nazwa" },

    ];
    return (
        <div>
            <CustomCard
                icon={<InfoIcon fontSize="large" color="primary" />}
                title="Tagi"
                subheader="Zarządzaj tagami w systemie"
                sx={{ mb: 4 }}
            >
                <Box sx={{ mb: 2 }}>
                    <Typography variant="body1" gutterBottom>
                        Na tej stronie zarządzasz wszystkimi dostępnymi tagami w systemie.
                        Możesz przeglądać listę istniejących tagów.
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        Skorzystaj z przycisków, aby dodać nowy tag lub usunąć
                        wybrane pozycje.
                    </Typography>
                </Box>

                <ActionButtons
                    onCreate={handleCreate}
                    onDeleteSelected={handleDeleteSelected}
                />
            </CustomCard>
            <CustomCard >
                <DataTable
                    columns={columns}
                    data={data || []}
                    isLoading={isLoading}
                    isError={isError}
                    errorMessage={(error as any)?.data?.message}
                    getRowId={(row) => row.id}
                    onEdit={(id) => {
                        const item = data?.find(item => item.id === id);
                        if (item) {
                            navigate(TagsRoutes.update.replace(":tagId", item.id.toString()));
                        }
                    }}
                    page={page}
                    rowsPerPage={rowsPerPage}
                    onPageChange={(newPage) => setPage(newPage)}
                    onRowsPerPageChange={(newSize) => {
                        setRowsPerPage(newSize);
                        setPage(0);
                    }}
                    selected={selectedTagIds}
                    onSelectionChange={(selectedIds) => {
                        setSelectedTagIds(selectedIds);
                    }}
                />
            </CustomCard>
        </div>
    )
}

export default Tags